import { GetPageQuery } from "apollo"
import { getUmbracoMediaUrl } from "."
import { extractProperty } from "./extractProperty"
import { findProperty } from "./findProperty"

export type MetaData = {
  pageSlug: string | undefined
  metaTitle: string | undefined
  metaKeywords: string | undefined
  metaDescription: string | undefined
  robotsTxt: string | undefined
  canonicalUrl: string | undefined
  oldUrls: string[]
  jsonPdSchema: string | undefined
}
export type Category = {
  metaData: MetaData
}

export function getMataTag(object: any, fallbackPageData?: any) {
  const metaTitle =
    (extractProperty(object, "metaTitle") as string | undefined) ||
    extractHeadingTitle(object) ||
    (fallbackPageData && fallbackPageData !== object
      ? extractHeadingTitle(fallbackPageData)
      : undefined)

  return {
    pageSlug: extractProperty(object, "pageslug") as string | undefined,
    metaTitle,
    metaKeywords: extractProperty(object, "metaKeywords") as string | undefined,
    metaDescription: extractProperty(object, "metaDescription") as string | undefined,
    robotsTxt:
      (extractProperty(object, "robotsTxt") as string | undefined) ||
      process.env.ENV?.includes("production")
        ? {
            index: true,
            follow: true,
          }
        : {
            index: false,
            follow: false,
          },
    canonicalUrl: extractProperty(object, "canonicalUrl") as string | undefined,
    oldUrls: extractProperty(object, "oldUrls") as string[],
    titleBreadcrumbs: extractProperty(object, "titleBreadcrumbs") as string | undefined,
    ogImage: getUmbracoMediaUrl(extractProperty(object, "ogImageSHARE") as string | undefined),
    jsonPdSchema: extractProperty(object, "jsonPdSchema") as string | undefined,
  }
}

function extractHeadingTitle(data: any) {
  const titleCandidates = [
    "titleH1",
    "mainTitle",
    "articleMainTitle",
    "conetntTitle",
    "blockMainTitle",
    "projectTitle",
  ]

  for (const field of titleCandidates) {
    const candidate = coercePropertyValue(findProperty(data, field))
    if (candidate) {
      return candidate
    }
  }

  const fallbackMeta = coercePropertyValue(findProperty(data, "titleBreadcrumbs"))
  if (fallbackMeta) {
    return fallbackMeta
  }

  return undefined
}

function stripHtmlTags(str: string): string {
  return str.replace(/<[^>]*>/g, "").trim()
}

function coercePropertyValue(propertyValue: any) {
  if (!propertyValue) {
    return ""
  }

  if (typeof propertyValue === "string") {
    return stripHtmlTags(propertyValue)
  }

  const value = propertyValue?.value || propertyValue?.richText

  return typeof value === "string" ? stripHtmlTags(value) : ""
}
type Props = {
  itemsData: GetPageQuery
  infoBlock?: boolean
}
export function extractMetaTags({ itemsData }: Props) {
  let object = itemsData.page
  const originalPage = itemsData.page

  const pageBlock = extractProperty(object, "pageInfoAndMetaTags")
  const pageInfo = extractProperty(object, "pageInfoBlockContent")
  if (pageBlock) {
    object = pageBlock?.[0]
  } else if (pageInfo) {
    object = pageInfo?.[0]
  } else {
    // Try to extract from innerPageInfo structure
    const innerPageInfo = object // This is your innerPageInfo object
    // Extract the pageInfoAndMetaTags property from innerPageInfo
    const pageInfoAndMetaTags = extractProperty(innerPageInfo, "pageInfoAndMetaTags")

    if (pageInfoAndMetaTags) {
      // Handle case where pageInfoAndMetaTags is an array of blocks
      if (Array.isArray(pageInfoAndMetaTags)) {
        object = pageInfoAndMetaTags[0]
      } else {
        object = pageInfoAndMetaTags
      }
    }
  }
  const metaData = getMataTag(object, originalPage)

  return metaData
}
